/** @format */

import {styled} from '@mui/material/styles';
import {Button} from '@mui/material';

export const Root = styled(Button)(({theme}) => ({
  height: '32px',
  backgroundColor: theme.palette.semantic_light?.surface.surface2,
  gap: theme.spacing(2),
  width: 'max-content',
  transition: '0.2s',

  color: theme.palette.figma_gray_dark_5?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',

  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.surface.onSurfaceMuted,
  },

  '.MuiSvgIcon-root': {
    transition: '0.2',
    color: theme.palette.figma_gray_dark_5?.main,
    fontSize: '14px',
  },

  '.MuiCircularProgress-root': {
    color: 'rgba(0, 0, 0, 0.26)',
  },

  '&.Mui-disabled .MuiSvgIcon-root': {
    color: 'rgba(0, 0, 0, 0.26)',
  },
}));
